"use client";

import React, { useState } from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Loader2, AlertCircle } from "lucide-react";
function CasesGrid() {
  const {
    posts,
    loading,
    error,
    setQuery
  } = usePosts();
  const [activeFilter, setActiveFilter] = useState("all");
  const handleFilterChange = (value: string) => {
    if (!value) return;
    setActiveFilter(value);
    if (value === "all") {
      setQuery({
        project_category: undefined
      });
    } else {
      setQuery({
        project_category: value
      });
    }
  };
  if (error) {
    return <div data-section-id="234492" className="flex flex-col items-center justify-center py-12 text-center">
        <AlertCircle className="size-10 text-destructive mb-4" />
        <p className="text-lg font-medium text-foreground">Não foi possível carregar o portfólio.</p>
        <p className="text-muted-foreground mt-2">Por favor, tente novamente em instantes.</p>
      </div>;
  }
  return <div className="flex flex-col items-center w-full">
      <ToggleGroup type="single" value={activeFilter} onValueChange={handleFilterChange} className="mb-10 flex-wrap justify-center gap-2">
        <ToggleGroupItem value="all" aria-label="Todos os projetos" className="rounded-full border-border text-muted-foreground data-[state=on]:bg-primary data-[state=on]:text-primary-foreground">
          Todos
        </ToggleGroupItem>
        <ToggleGroupItem value="branding" aria-label="Branding" className="rounded-full border-border text-muted-foreground data-[state=on]:bg-primary data-[state=on]:text-primary-foreground">
          Branding
        </ToggleGroupItem>
        <ToggleGroupItem value="digital" aria-label="Digital" className="rounded-full border-border text-muted-foreground data-[state=on]:bg-primary data-[state=on]:text-primary-foreground">
          Digital
        </ToggleGroupItem>
        <ToggleGroupItem value="editorial" aria-label="Editorial" className="rounded-full border-border text-muted-foreground data-[state=on]:bg-primary data-[state=on]:text-primary-foreground">
          Editorial
        </ToggleGroupItem>
      </ToggleGroup>

      {loading ? <div className="flex justify-center items-center py-20 w-full">
          <Loader2 className="size-10 animate-spin text-primary" />
        </div> : posts.length === 0 ? <div className="text-center py-20 w-full">
          <p className="text-lg text-muted-foreground">Nenhum projeto encontrado nesta categoria.</p>
        </div> : <div className="columns-1 md:columns-2 lg:columns-3 gap-8 w-full">
          {posts.map((post, i) => <div key={post.id} data-index={i} className="break-inside-avoid mb-8 group relative rounded-none overflow-hidden border-none bg-background shadow-none transition-all duration-500 flex flex-col">
              <div className="relative w-full overflow-hidden bg-muted aspect-[16/9]">
                {}
                <img src={post.featuredImage || `/img/studio_portfolio_${i % 3 + 1}.png`} alt={post.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105 grayscale-[0.2] group-hover:grayscale-0" />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-b from-white/90 to-white/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-center items-center text-foreground p-6 text-center z-10 backdrop-blur-[2px]">
                  <h4 className="text-sm font-bold mb-2 font-default text-foreground uppercase tracking-widest">Cliente</h4>
                  <p className="text-xl font-default text-foreground mb-4">{post.customFields?.client_name || "Marca Global"}</p>
                  <div className="w-12 h-px bg-foreground/20 mx-auto my-2"></div>
                  <p className="flex flex-col items-center">
                    <span className="text-foreground/60 text-xs uppercase tracking-widest">Tipo de Projeto</span>
                    <span className="font-medium font-default">{post.customFields?.project_type || "Identidade Visual"}</span>
                  </p>
                </div>
              </div>
              
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex gap-2 mb-3 flex-wrap">
                  {post.categories && post.categories.length > 0 ? post.categories.slice(0, 2).map(cat => <Badge key={cat.id} variant="secondary" className="bg-transparent text-muted-foreground font-mono text-[10px] uppercase tracking-tighter border-none p-0">
                        // {cat.name}
                      </Badge>) : <Badge variant="secondary" className="bg-transparent text-muted-foreground font-mono text-[10px] uppercase tracking-tighter border-none p-0">
                      // Estúdio
                    </Badge>}
                </div>
                
                <h3 className="text-2xl font-bold text-foreground mb-4 font-default line-clamp-2 tracking-tight">
                  {post.title}
                </h3>
                
                <div className="mt-auto pt-2">
                  <Link to={post.link || "#"} className="w-full block">
                    <Button variant="link" className="w-full p-0 justify-start text-foreground font-default font-semibold hover:text-primary transition-colors duration-300">
                      Explorar Projeto →
                    </Button>
                  </Link>
                </div>
              </div>
            </div>)}
        </div>}
    </div>;
}
export default function OurCases() {
  const wp_query_params = {
    post_type: "project",
    per_page: 9,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="prova-social" className="py-24 md:py-32 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6 font-default tracking-tighter">
            Curadoria de Projetos
          </h2>
          <p className="text-xl text-muted-foreground font-default leading-relaxed">
            Uma seleção de trabalhos que definem nossa busca pela excelência estética e funcionalidade atemporal.
          </p>
        </div>
        
        <PostsProvider wp_query={{
        post_type: "project",
        per_page: 9,
        order: "desc",
        orderby: "date"
      }}>
          <CasesGrid />
        </PostsProvider>
      </div>
    </section>;
}